import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

type MenuSectionBlockProps = {
  title: string
  children: ReactNode
  className?: string
  /** Show a subtle top divider — default true */
  divider?: boolean
}

export function MenuSectionBlock({
  title,
  children,
  className,
  divider = true,
}: MenuSectionBlockProps) {
  return (
    <section
      className={cn(
        divider && 'border-t border-hairline/60 pt-6',
        className,
      )}
    >
      <h3 className="font-sans text-[length:var(--menu-fs-xs)] font-medium uppercase tracking-[0.14em] text-muted">
        {title}
      </h3>
      <div className="mt-3">{children}</div>
    </section>
  )
}
